/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { grafanaVerifyInternalGrafanaVerifyGet } from '../fn/internal/grafana-verify-internal-grafana-verify-get';
import { GrafanaVerifyInternalGrafanaVerifyGet$Params } from '../fn/internal/grafana-verify-internal-grafana-verify-get';

@Injectable({ providedIn: 'root' })
export class BackendApiInternalService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `grafanaVerifyInternalGrafanaVerifyGet()` */
  static readonly GrafanaVerifyInternalGrafanaVerifyGetPath = '/internal/grafana-verify';

  /**
   * nginx auth_request: валидация JWT и подготовка X-WEBAUTH-USER для Grafana.
   *
   * Эндпоинт для nginx `auth_request` в server-блоке `grafana.analytics.*`. На каждый запрос Grafana SPA nginx делает subrequest сюда; мы валидируем JWT и возвращаем `X-Webauth-User` для последующего проксирования к Grafana (`[auth.proxy]`). Источник токена: `?auth_token=` в URL (первичный iframe-load) ИЛИ cookie с именем из `GRAFANA_AUTH_COOKIE_NAME` (последующие XHR). На успешный response с query-токеном вешаем `Set-Cookie`, чтобы XHR-ы могли пройти без токена в URL.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `grafanaVerifyInternalGrafanaVerifyGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  grafanaVerifyInternalGrafanaVerifyGet$Response(
    params?: GrafanaVerifyInternalGrafanaVerifyGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<any>> {
    return grafanaVerifyInternalGrafanaVerifyGet(this.http, this.rootUrl, params, context);
  }

  /**
   * nginx auth_request: валидация JWT и подготовка X-WEBAUTH-USER для Grafana.
   *
   * Эндпоинт для nginx `auth_request` в server-блоке `grafana.analytics.*`. На каждый запрос Grafana SPA nginx делает subrequest сюда; мы валидируем JWT и возвращаем `X-Webauth-User` для последующего проксирования к Grafana (`[auth.proxy]`). Источник токена: `?auth_token=` в URL (первичный iframe-load) ИЛИ cookie с именем из `GRAFANA_AUTH_COOKIE_NAME` (последующие XHR). На успешный response с query-токеном вешаем `Set-Cookie`, чтобы XHR-ы могли пройти без токена в URL.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `grafanaVerifyInternalGrafanaVerifyGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  grafanaVerifyInternalGrafanaVerifyGet(
    params?: GrafanaVerifyInternalGrafanaVerifyGet$Params,
    context?: HttpContext,
  ): Observable<any> {
    return this.grafanaVerifyInternalGrafanaVerifyGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<any>): any => r.body),
    );
  }
}
